/**
 * Escapes a value for interpolation into a double-quoted HTML attribute of the
 * auto-submitting form documents the viewer components hand to their iframes
 * (certificate previews and the temp-document viewer). Those documents are
 * served from a `blob:` URL, which inherits the app's origin, so an unescaped
 * quote in a payload field (`period`, `flag`, `doc_type`, …) would let injected
 * markup run script with the app's own privileges.
 *
 * Escaping is transparent to the endpoint: the browser decodes the entities
 * when it parses the attribute, so the viewer receives exactly the characters
 * that were passed in.
 * @param value - Raw attribute value, typically a viewer payload field.
 * @returns The value with `&`, `<`, `>`, `"` and `'` replaced by entities.
 */
export function escapeHtmlAttribute(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
